import React, {Component} from 'react';
import 'swiper/swiper.min.css';
import {SubTabTableArea} from "communitypage/blog/BlogPage";
import styled from "styled-components";
import img_btn_a_left from "images/community/btn_a_left.svg";
import img_btn_a_right from "images/community/btn_a_right.svg";
import axios from "axios";
import {IfBestTagEntity} from "models/IfBestTagEntity";
import {IfBestDocEntity} from "models/IfBestDocEntity";
import {IfBestUserEntity} from "models/IfBestUserEntity";
import SimpleUserProfile from "communitypage/common/SimpleUserProfile";
import svcs from "services";
import {langutil} from "language/langutil";

interface Props {
  /*  selectedCategoryId: number;
    languageService: LanguageService;
    categoryRepository: CategoryRepository;
    ssqDataRepository: SsqDataRepository;
    categoryStore: CategoryStore; */
  getTranslation: Function;
  clickedTag?: Function;
  page: "QNA" | "BLOG" | "BOARD";
  displayLoginPopup: Function;
}


interface State {
  /* selectedDocType: string;
   ssqDataDocuments: ISsqDataDocument[];
   ssqDataVersion: string;
   ssqDataDocumentsCounts: ICountsOfEachDocType;
   pageNum: number;
   isMobile: boolean;*/
  bestTag: IfBestTagEntity[];
  bestDoc: IfBestDocEntity[];
  bestUser: IfBestUserEntity[];
  yearQrtr: string;
}


class AsidePanel extends Component<Props, State> {
  constructor(props: Props) {
    super(props);
    this.state = {
      bestTag: [],
      yearQrtr: '',
      bestDoc: [],
      bestUser: [],
    };
  }

  componentDidMount() {
    this.setState({yearQrtr: this.getCurrentQrtr()});
    axios.get('/api/guest/ssqData/besttaglist/list', {params: {yearQrtr: this.getCurrentQrtr(), lang: svcs.svcLang.lang()}})
      .then(res => {
        this && this.setState && typeof this.setState === 'function' && this.setState({
          bestTag: res.data || [],
        });
      });

    axios.get('/api/guest/ssqData/bestdoclist/list', {params: {yearQrtr: this.getCurrentQrtr(), type: this.props.page, lang: svcs.svcLang.lang()}})
      .then(res => {
        this && this.setState && typeof this.setState === 'function' && this.setState({
          bestDoc: res.data || [],
        });
      });

    axios.get('/api/guest/ssqData/bestuserlist/list', {params: {yearQrtr: this.getCurrentQrtr()}})
      .then(res => {
        this && this.setState && typeof this.setState === 'function' && this.setState({
          bestUser: res.data || [],
        });
      });
  }

  // getCurrentQrtr() {
  //   let currentDate = new Date();
  //   let qrtr = currentDate.getMonth() < 3 ? '4' : currentDate.getMonth() < 6 ? '1' : currentDate.getMonth() < 9 ? '2' : '3';
  //   let year = qrtr === '4' ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
  //   return `${year}Q${qrtr}`;
  // }

  getYyyymm(d: Date) {
    return `${d.getFullYear()}` + ('' + (d.getMonth() + 1)).padStart(2, '0');
  }

  getCurrentQrtr() {
    // const currentDate = new Date();
    // const qrtr = currentDate.getMonth() < 3 ? '1' : currentDate.getMonth() < 6 ? '2' : currentDate.getMonth() < 9 ? '3' : '4';
    // //let year = qrtr === '4' ? currentDate.getFullYear() - 1 : currentDate.getFullYear();
    // const year = currentDate.getFullYear();
    // return `${year}Q${qrtr}`;


    const d = new Date();
    d.setDate(d.getDate() - 1);

    return this.getYyyymm(d);

  }

  buttonClick(direction: string) {
    // let [year, qrtr] = this.state.yearQrtr.split('Q');
    // if (direction === 'l') {
    //   if (this.state.yearQrtr !== "2022Q3") {
    //     if (qrtr === '1') this.setState({yearQrtr: `${parseInt(year) - 1}Q4`});
    //     else this.setState({yearQrtr: `${year}Q${parseInt(qrtr) - 1}`});
    //   }
    // } else if (direction === 'r') {
    //   if (this.getCurrentQrtr() !== this.state.yearQrtr) {
    //     if (qrtr === '4') this.setState({yearQrtr: `${parseInt(year) + 1}Q1`});
    //     else this.setState({yearQrtr: `${year}Q${parseInt(qrtr) + 1}`});
    //   }
    // }

    //let [year, qrtr] = this.state.yearQrtr.split('Q');
    /*
    2022Q3  2022Q4, 2023Q1, 2023Q2, 2023Q3
    202209, 202212, 202303, 202306, 202309
     */
    const months = ['202209', '202212', '202303', '202306', '202308'];
    if (direction === 'l') {
      if (this.state.yearQrtr !== "202209") {
        const ym = this.state.yearQrtr;
        if (ym <= '202308') {
          const idx = months.indexOf(ym);
          const nym = months[idx - 1];
          const d = new Date(Number(nym.substring(0, 4)), Number(nym.substring(4, 6)) - 1, 1);
          this.setState(({yearQrtr: this.getYyyymm(d)}));
        } else {
          const d = new Date(Number(ym.substring(0, 4)), Number(ym.substring(4, 6)) - 1, 1);
          d.setMonth(d.getMonth() - 1);
          this.setState(({yearQrtr: this.getYyyymm(d)}));
        }

      }
    } else if (direction === 'r') {
      if (this.getCurrentQrtr() !== this.state.yearQrtr) {
        const ym = this.state.yearQrtr;
        if (ym < '202308') {
          const idx = months.indexOf(ym);
          const nym = months[idx + 1];
          const d = new Date(Number(nym.substring(0, 4)), Number(nym.substring(4, 6)) - 1, 1);
          this.setState(({yearQrtr: this.getYyyymm(d)}));
        } else {
          const d = new Date(Number(ym.substring(0, 4)), Number(ym.substring(4, 6)) - 1, 1);
          d.setMonth(d.getMonth() + 1);
          this.setState(({yearQrtr: this.getYyyymm(d)}));
        }
      }
    }
  }

  componentDidUpdate(prevProps: Readonly<Props>, prevState: Readonly<State>, snapshot?: any) {
    if (prevState.yearQrtr !== this.state.yearQrtr) {
      axios.get('/api/guest/ssqData/besttaglist/list', {params: {yearQrtr: this.state.yearQrtr, lang: svcs.svcLang.lang()}})
        .then(res => {
          this.setState({
            bestTag: res.data || [],
          });
        });

      axios.get('/api/guest/ssqData/bestdoclist/list', {params: {yearQrtr: this.state.yearQrtr, type: this.props.page, lang: svcs.svcLang.lang()}})
        .then(res => {
          this.setState({
            bestDoc: res.data || [],
          });
        });

      axios.get('/api/guest/ssqData/bestuserlist/list', {params: {yearQrtr: this.state.yearQrtr}})
        .then(res => {
          this.setState({
            bestUser: res.data || [],
          });
        });
    }

  }

  AsidePanel() {
    const {country, lang} = langutil.splitLangCode(svcs.svcLang.lang());


    const getYmd = () => {
      const ymd = this.state.yearQrtr;
      return `${ymd.substring(0, 4)}-${ymd.substring(4, 6)}`;
    };

    return <>
      <div className="community__content">

        <aside className="community-aside">
          <div className="aside-header">
            <div className="tag-arrow">
              <button className="btn-a-left" onClick={() => this.buttonClick('l')}></button>
              <span>{getYmd()}</span>
              <button className="btn-a-right" onClick={() => this.buttonClick('r')}></button>
            </div>
          </div>
          {/*베스트USER*/}
          <div className="tag-best-mem">
            <p className="title">{this.props.getTranslation('I18N_COMMUNITY_BEST_USER')}</p>
            {
              this.state.bestUser.map((user, index) => (
                index < 5 && <SimpleUserProfile key={user.userId} userId={user.userId} rank={index + 1} qrtrTechPoint={user.qrtrTechPoint}
                  displayLoginPopup={this.props.displayLoginPopup}
                />
              ))
            }
          </div>
          {/*베스트DOC*/}
          <div className="tag-best-document">
            <p className="title">{this.props.getTranslation(`I18N_COMMUNITY_BEST_${this.props.page}`)}</p>
            <ul>
              {this.state.bestDoc.map((doc, index) => (
                index < 5 &&
                <li key={index}>
                  <span className="best-number">{index + 1}</span>
                  <span className="best-content cursor-pointer" onClick={() => {
                    window.open(`/${country}/${lang}/community/${this.props.page.toLowerCase()}/document/${doc.docId}`);
                  }}>{doc.docTitle}</span>
                </li>
              ))}
            </ul>
          </div>
          {/*베스트TAG*/}
          <div className="best-item">
            <div className="tag-best">
              <p className="title">{this.props.getTranslation('I18N_COMMUNITY_BEST_TAG')}</p>
              <ul className="tag-content">
                {this.state.bestTag.map((tag, index) => (
                  index < 15 && <li key={tag.tag} onClick={e => {
                    this.props.clickedTag(tag.tag);
                  }}>#{tag.tag}</li>
                ))}
              </ul>
            </div>


          </div>
        </aside>
      </div>
    </>;
  }

  render() {
    return (
      <AsidePanelBody>
        <AsidePanelContainer>
          {/*데이터 출력되는 곳*/}
          <SubTabTableArea>
            <div className={"result-area"}>
              {this.AsidePanel()}
            </div>
          </SubTabTableArea>
        </AsidePanelContainer>
      </AsidePanelBody>
    );
  }
}

export default AsidePanel;

export const AsidePanelBody = styled.div`

  @media screen and (max-width: 1199px) {
    width: 100%;
  }

`;

export const AsidePanelContainer = styled.div`


  /* 오른쪽 aside */

  aside.community-aside {
    padding-right: 3.2rem;
  }

  .aside-header {
    display: flex;

  }

  .aside-header .tag-arrow {
    display: flex;
    justify-content: space-between;
    width: 100%;
  }

  .aside-header .tag-arrow > button {
    width: 2.4rem;
    height: 2.4rem;
  }

  .aside-header .tag-arrow .btn-a-left {
    background-image: url("${img_btn_a_left}");
    background-repeat: no-repeat;
  }

  .aside-header .tag-arrow .btn-a-right {
    background-image: url("${img_btn_a_right}");
    background-repeat: no-repeat;
    margin-left: -1px;
  }

  .aside-header .tag-arrow > span {
    height: 2.4rem;
    line-height: 2.4rem;
    color: #7783A1;
    font-weight: 500;
    font-size: 1.3rem;
    margin-left: .8rem;
  }

  .tag-best {
    margin-top: 3.2rem;
  }

  .tag-best > p.title {
    color: #7783A1;
    font-weight: 500;
    font-size: 1rem;
  }

  .tag-best > .tag-content {
    margin-top: .8rem;
    display: flex;
    flex-wrap: wrap;
  }

  .tag-best > .tag-content > li {
    color: #407DD8;
    font-size: 1.2rem;
    font-weight: 500;
    margin-right: .2rem;
    line-height: 2.8rem;
    padding-right: 1.6rem;
    border-radius: 10rem;
    cursor: pointer;
  }

  .tag-best > .tag-content > li:hover {
    color: #25426D;
  }

  .tag-best-mem {
    margin-top: 3.2rem;
  }

  .tag-best-mem > p.title {
    color: #7783A1;
    font-weight: 500;
    font-size: 1rem;
    vertical-align: middle;
    margin-bottom: .8rem;
  }

  .tag-best-mem .best-men-item {
    display: flex;
    align-items: center;
    margin-top: 1.2rem;
  }

  span.best-number {
    color: #7783A1;
    font-size: 1rem;
    font-weight: 500;
    width: 1.6rem;
    display: inline-block;
  }

  .tag-best-document {
    margin-top: 3.2rem;
  }

  .tag-best-document > p.title {
    color: #7783A1;
    font-weight: 500;
    font-size: 1rem;
    vertical-align: middle;
    margin-bottom: .8rem;
  }

  .tag-best-document .best-content {
    color: #407DD8;
    font-size: 1.2rem;
    font-weight: 500;
    line-height: 1.8rem;
    width: 18rem;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    display: inline-block;
  }

  .tag-best-document > ul {
    margin-top: 1.2rem;
  }

  .tag-best-document > ul > li {
    padding: .4rem 0;
    display: flex;
    align-items: center;
  }

  aside.community-aside ul.comment-box {
    display: flex;
    flex-wrap: wrap;
    margin-top: 0;
  }

  aside.community-aside ul.comment-box > li {
    margin-right: 1rem;
    font-size: 1.2rem;
    color: #7783A1;
    font-weight: 500;
    margin-top: 0
  }

  @media screen and (max-width: 1199px) {
    .aside-header .tag-arrow {
      width: 33%;
      padding-right: 3rem;
    }
  }
  @media (min-width: 768px) and (max-width: 1199px) {
    aside.community-aside {
      padding-right: 3.2rem;
      flex-wrap: wrap;
      display: flex;

      > div {
        width: 33%;
      }

      > div:first-child {
        width: 100%;
        justify-content: center;
      }
    }
  }
  @media screen and (max-width: 764px) {
    .aside-header .tag-arrow {
      width: 100%;
      padding-right: 0;
    }

  }





`;
